import { z } from "zod";
import { adminCountSchema, adminDaySchema } from "./common.js";
export const jobResultSchema = z.enum(["ok", "failed", "missed"]);
/** Each background job: when it should run, and what its last fourteen days were. */
export const adminJobsSchema = z.object({
    asOf: z.string(),
    jobs: z.array(z.object({
        id: z.string(),
        label: z.string(),
        schedule: z.string(),
        lastRunAt: z.string().nullable(),
        lastResult: jobResultSchema,
        lastDurationMs: adminCountSchema.nullable(),
        nextRunAt: z.string(),
        history: z.array(z.object({ day: adminDaySchema, result: jobResultSchema })),
    })),
});
//# sourceMappingURL=jobs.js.map